import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../services/api';

export const meKey = ['me'] as const;

/** The signed-in user, or null when signed out. Never throws for 401. */
export function useMe() {
  return useQuery({
    queryKey: meKey,
    queryFn: async () => {
      try {
        return await api.me();
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 30_000,
    retry: false,
  });
}

export function useSignIn() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.signIn,
    onSuccess: (user) => {
      qc.clear();
      qc.setQueryData(meKey, user);
    },
  });
}

export function useSignUp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.signUp,
    onSuccess: (user) => {
      qc.clear();
      qc.setQueryData(meKey, user);
    },
  });
}

export function useSignOut() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.signOut,
    onSettled: () => {
      // Drop every cached response so the next user never sees the previous user's data.
      qc.clear();
      qc.setQueryData(meKey, null);
    },
  });
}

export const usePublicInfo = () => useQuery({ queryKey: ['public-info'], queryFn: api.publicInfo, staleTime: 300_000 });
